// Make every predictive-search request also search variants.sku
(() => {
  const ensureSkuField = (urlStr) => {
    try {
      const u = new URL(urlStr, location.origin);
      if (!u.pathname.includes('/search/suggest')) return urlStr;

      // Make sure we include variants.sku among the searchable fields
      const key = 'resources[options][fields]';
      const current = (u.searchParams.get(key) || 'title,product_type,variants.title,vendor')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);

      if (!current.includes('variants.sku')) current.push('variants.sku');
      u.searchParams.set(key, current.join(','));

      // Optional: ensure products are included in types (some themes override this)
      const typeKey = 'resources[type]';
      const types = (u.searchParams.get(typeKey) || 'product,article,page,collection')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
      if (!types.includes('product')) types.unshift('product');
      u.searchParams.set(typeKey, Array.from(new Set(types)).join(','));

      return u.toString();
    } catch (_) {
      return urlStr;
    }
  };

  // ---- Patch fetch ----
  const origFetch = window.fetch;
  window.fetch = function(input, init) {
    let url = typeof input === 'string' ? input : input?.url;
    if (url && url.includes('/search/suggest')) {
      input = ensureSkuField(url);
    }
    return origFetch.call(this, input, init);
  };

  // ---- Patch XHR ----
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
    try {
      if (typeof url === 'string' && url.includes('/search/suggest')) {
        url = ensureSkuField(url);
      }
    } catch (_) {}
    return origOpen.call(this, method, url, async, user, password);
  };
})();
